import { MuiThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getSearchTextFieldTheme } from '../../config/MaterialTheme';
import searchIcon from './../../assets/images/svg/search-icon.svg';
import { CustomTextField } from './../CustomTextField';
import styles from './SearchTextField.scss';
import { getElementID, getMergedClassNames } from '../../utils/HTMLUtils';

const rootClassName = styles.rootClassName;

class SearchTextField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };

    this.toSearch = this.toSearch.bind(this);
  }

  setValue(value) {
    this.setState({
      ...this.state,
      value: value,
    });
  }

  toReset() {
    this.setValue('');
  }

  toSearch() {
    if (typeof this.props.onSearchClick === 'function') {
      this.props.onSearchClick(this.state.value);
      this.toReset();
    }
  }

  getSearchButton() {
    return (
      <button
        id={'contratos-search-button-new'}
        className={rootClassName + '-search-button'}
        disabled={this.props.disabled}
      >
        <img
          id='icon-search-contratos'
          src={searchIcon}
          alt='icone-pesquisa'
          loading='lazy'
          className={rootClassName + '-search-icon'}
        />
      </button>
    );
  }

  render() {
    return (
      <div
        className={getMergedClassNames([
          rootClassName,
          this.props.disabled ? rootClassName + '-disabled' : '',
        ])}
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            this.toSearch();
          }}
        >
          <MuiThemeProvider theme={getSearchTextFieldTheme()}>
            <CustomTextField
              id={
                this.props.id ? getElementID(this.props.id, 'text-field') : null
              }
              className={rootClassName + '-text-field'}
              value={this.state.value}
              onChange={(event) => this.setValue(event.target.value)}
              InputProps={{
                endAdornment: this.getSearchButton(),
                disabled: this.props.disabled,
                placeholder:
                  typeof this.props.placeholder === 'string'
                    ? this.props.placeholder
                    : '',
              }}
            />
          </MuiThemeProvider>
        </form>
      </div>
    );
  }
}

SearchTextField.propTypes = {
  id: PropTypes.string,
  onSearchClick: PropTypes.func,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default SearchTextField;
